import { Observable } from 'rxjs';
import { UserAccessResult } from '../models/user-access.model';

/** Port abstracto para verificar el acceso del usuario. */
export abstract class UserAccessRepository {
  abstract checkAccess(): Observable<UserAccessResult>;
}
